/*
  L7 Warenkorb (15.10.2026, Konzept redesign/content/warenkorb/KONZEPT.md §3–4). Lädt mit defer auf jeder Seite (sections/quick-cart).
  1. Mischform nach „In den Warenkorb“:
     - Produktformulare (form[action*="/cart/add"], nicht [data-gw-wk]) übernimmt dieses Script in der Capture-Phase (Stiletto-onFormSubmit
       läuft dann nicht): POST /cart/add.js → Ereignis „apps:product-added-to-cart“ (Stiletto aktualisiert damit Zähler und Drawer, ohne zu öffnen).
     - Direktkauf-Kacheln [data-gw-wk] (assets/gw-home-warenkorb.js) melden sich über window.gwWk.hinzugefuegt().
     - Erster Artikel der Sitzung (sessionStorage gw_wk_erst fehlt): großer Warenkorb (Desktop Drawer, mobil Bottom-Sheet) mit Bestätigungszeile,
       die nach ca. 4 s einklappt. Jeder weitere Artikel: Desktop Karte am Warenkorb-Symbol, mobil verwandelt sich die klebende Kaufleiste
       ca. 3,5 s in eine Bestätigungsleiste, ohne sichtbare Kaufleiste eine schmale Snackbar. Kein Dialog, Fokus bleibt, Ausblenden pausiert bei
       Maus/Fokus, Esc schließt. Ansage immer über eine eigene role=status-Region außerhalb des neu gerenderten Inhalts.
     - Fehler (ausverkauft, Höchstmenge): kein Erfolgshinweis, Meldung am Kaufknopf (role=alert).
  2. Drawer/Sheet: Esc schließt, Fokus zurück zum Auslöser, Wischen nach unten (ab 110 px) schließt das Sheet (Zusatzgeste; Schließen-Knopf,
     Esc und Hintergrund bleiben), „−“ bei Menge 1 gesperrt, Ansage und Fokus nach Mengenänderung/Entfernen (Drawer und Warenkorbseite).
  L9 (16.10.2026) Ladezustand: Kaufknöpfe zeigen sofort die Theme-Ladelinie (Stiletto .btn.loading / .btn__loading-bar, auf Kaufleiste, Pill und
     Karten als .gw-laedt nachgebaut, gleiche Animation loaderLine), aria-busy + aria-disabled, Sperre gegen Mehrfachklick, Ansage
     „Wird zum Warenkorb hinzugefügt“, Rückfall nach 10 s. Fehlertexte: 422 „Leider nicht mehr genug auf Lager“, sonst „Hat nicht geklappt“.
     API window.gwWk.ladenAn/ladenAus/fehlerText (auch für assets/gw-home-warenkorb.js).
  3. Warenkorb-Symbol: Zähler skaliert kurz (nicht bei reduzierter Bewegung). Warenkorbseite: Notiz wird beim Verlassen des Feldes gespeichert.
  Ohne JS bleibt alles beim normalen Formular an /cart/add bzw. /cart.
*/
(function () {
  if (window.gwWk) return;
  if (!window.fetch || !window.FormData || !document.querySelector) return;
  var d = document;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MERKER = 'gw_wk_erst';
  var mqMobil = window.matchMedia('(max-width: 767px)');
  var mqRuhig = window.matchMedia('(prefers-reduced-motion: reduce)');

  function ss(k, v) {
    try { if (v === undefined) return window.sessionStorage.getItem(k); window.sessionStorage.setItem(k, v); } catch (e) { return null; }
    return null;
  }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function land() { return window.gwLand === 'at' ? 'at' : 'de'; }
  function qc() { return d.querySelector('.quick-cart.gw-wk'); }
  function wrapper() { var q = qc(); return q && q.querySelector('.quick-cart__wrapper'); }
  function istOffen() { var w = wrapper(); return !!(w && w.classList.contains('active')); }
  function seite() { return d.querySelector('.gw-wk-seite[data-section-type="cart"]'); }
  function daten(root) { var el = (root || d).querySelector('[data-gw-wk-daten]'); return el ? el.dataset : null; }
  function versandSatz(dt) { return dt ? (land() === 'at' ? dt.at : dt.de) : ''; }
  function sichtbar(el) { return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }

  var ICON = {
    check: '<svg class="gw-wk-i" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="10"/><path d="m8 12 3 3 5-6"/></svg>',
    x: '<svg class="gw-wk-i" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M18 6 6 18M6 6l12 12"/></svg>'
  };

  /* ---------- Ansagen (außerhalb des neu gerenderten Warenkorbs) ---------- */
  var live = d.createElement('div');
  live.className = 'visually-hidden gw-wk-live';
  live.setAttribute('role', 'status');
  live.setAttribute('aria-live', 'polite');
  live.setAttribute('aria-atomic', 'true');
  live.style.cssText = 'position:absolute!important;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0';
  d.body.appendChild(live);
  var liveT;
  function ansage(t) { clearTimeout(liveT); live.textContent = ''; liveT = setTimeout(function () { live.textContent = t; }, 80); }

  /* ---------- Ladezustand an Kaufknöpfen (L9) ---------- */
  var LADE_MS = 10000;
  /* Aussehen: dieselbe Ladelinie wie der Theme-Kaufknopf (.btn.loading .btn__loading-wrap/.btn__loading-bar, Animation loaderLine),
     Inhalt bleibt unsichtbar im Fluss (Breite/Höhe stabil). Reduzierte Bewegung: stehende, sanft pulsierende Linie (auch am Theme-Knopf). */
  (function () {
    if (d.getElementById('gw-laden-css')) return;
    var st = d.createElement('style'); st.id = 'gw-laden-css';
    st.textContent = 'button.gw-laedt{position:relative;color:transparent!important;pointer-events:none;cursor:progress}button.gw-laedt>:not(.gw-lw){visibility:hidden}button.gw-laedt>.gw-lw{display:block;position:absolute;top:50%;left:50%;width:100%;max-width:50px;height:2px;margin:0;overflow:hidden;transform:translate(-50%,-50%);visibility:visible}button.gw-laedt>.gw-lw .btn__loading-bar{display:block;width:100%;height:2px;border-radius:2px;background-color:#fff;animation:loaderLine 1.4s ease-in-out infinite}.btn.loading,.product-form__cart-submit[aria-busy=true]{pointer-events:none;cursor:progress}.btn.loading .gw-a-atc-ic{opacity:0}.gw-lade-fehler{position:absolute;left:16px;right:16px;bottom:calc(100% + 8px);max-width:480px;margin:0 auto;display:flex;align-items:center;gap:8px;padding:8px 12px;border-radius:8px;background:#FDECEA;color:#8C1D18;border:1px solid #8C1D18;font-size:14px;line-height:1.4;box-shadow:0 4px 12px rgba(0,0,0,.12);pointer-events:none}.gw-lade-fehler__i{flex:0 0 20px;width:20px;height:20px;border-radius:50%;background:#8C1D18;color:#fff;font-weight:700;font-size:13px;line-height:20px;text-align:center}.gw-wk-pd__fehler{grid-column:1/-1;margin-top:6px}@media (min-width:750px){.gw-lade-fehler{left:auto;right:16px;margin:0}}@keyframes gwLinieRuhig{from{opacity:1}to{opacity:.35}}@media (prefers-reduced-motion:reduce){.btn__loading-bar,button.gw-laedt>.gw-lw .btn__loading-bar{animation:gwLinieRuhig 1.6s ease-in-out infinite alternate!important;transform:none!important}}';
    d.head.appendChild(st);
  })();
  function ladeZiele(btns, form) {
    var z = btns.slice();
    if (form && form.closest && form.closest('.product__meta')) {
      var s = d.getElementById('gw-sticky-atc');
      if (s) Array.prototype.forEach.call(s.querySelectorAll('[data-gw-btn],[data-gw-pbtn]'), function (b) { if (z.indexOf(b) < 0) z.push(b); });
    }
    return z;
  }
  function ladenAn(btns, beiZeitablauf) {
    var tok = { btns: btns, aus: false };
    btns.forEach(function (b) {
      b._gwAltAD = b.getAttribute('aria-disabled');
      b.setAttribute('aria-busy', 'true');
      b.setAttribute('aria-disabled', 'true');
      if (b.classList.contains('btn') && b.querySelector('.btn__loading-wrap')) { b.classList.add('loading'); return; }
      b.classList.add('gw-laedt');
      if (!b.querySelector('.gw-lw')) {
        var w = d.createElement('span');
        w.className = 'btn__loading-wrap gw-lw'; w.setAttribute('aria-hidden', 'true');
        w.innerHTML = '<span class="btn__loading-bar"></span>';
        b.appendChild(w);
      }
    });
    ansage('Wird zum Warenkorb hinzugefügt');
    tok.t = setTimeout(function () { ladenAus(tok); if (beiZeitablauf) beiZeitablauf(); }, LADE_MS);
    return tok;
  }
  function ladenAus(tok) {
    if (!tok || tok.aus) return;
    tok.aus = true; clearTimeout(tok.t);
    tok.btns.forEach(function (b) {
      b.classList.remove('loading', 'gw-laedt');
      b.removeAttribute('aria-busy');
      if (b._gwAltAD === null || b._gwAltAD === undefined) b.removeAttribute('aria-disabled'); else b.setAttribute('aria-disabled', b._gwAltAD);
      var w = b.querySelector('.gw-lw'); if (w) w.parentNode.removeChild(w);
    });
  }
  /* Bei 422 legt Shopify oft die verfügbare Restmenge trotzdem in den Warenkorb: Zähler und Drawer auffrischen */
  function nachFehler(status) {
    if (status === 422) d.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { detail: {} }));
  }
  function fehlerText(status, beschreibung) {
    if (status === 422) return 'Leider nicht mehr genug auf Lager.' + (beschreibung ? ' ' + beschreibung : '');
    return 'Hat nicht geklappt – bitte erneut versuchen.';
  }
  /* Sichtbarer Hinweis über Kaufleiste/Pill, solange diese sichtbar ist (Haupt-Kaufknopf dann außer Sicht; Ansage übernimmt role=alert am Haupt-Kaufknopf) */
  var leistenFehlerT;
  function leistenFehler(text) {
    var s = d.getElementById('gw-sticky-atc');
    if (!s || !s.classList.contains('is-visible')) return;
    var el = s.querySelector('.gw-lade-fehler');
    if (!el) { el = d.createElement('p'); el.className = 'gw-lade-fehler'; el.setAttribute('aria-hidden', 'true'); s.appendChild(el); }
    el.innerHTML = '<span class="gw-lade-fehler__i">!</span>' + esc(text);
    clearTimeout(leistenFehlerT);
    leistenFehlerT = setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 6000);
  }

  /* ---------- Warten auf den Neuaufbau durch Stiletto (Section Rendering) ---------- */
  var warter = [];
  function warteAufRefresh(ms) {
    return new Promise(function (res) {
      var w = { res: res };
      w.t = setTimeout(function () { warter = warter.filter(function (x) { return x !== w; }); res(false); }, ms || 2500);
      warter.push(w);
    });
  }
  function refreshFertig() {
    var ws = warter; warter = [];
    ws.forEach(function (w) { clearTimeout(w.t); w.res(true); });
  }

  /* ---------- Bestätigungszeile im Drawer (Variante B) ---------- */
  var best = null, bestT = null;
  function setzeBest() {
    var q = qc(); if (!q || !best) return;
    var slot = q.querySelector('[data-gw-wk-best]'); if (!slot || slot.firstChild) return;
    slot.innerHTML = '<p class="gw-wk-best' + (best.zu ? ' gw-wk-best--zu' : '') + '">' + ICON.check + '<span class="gw-wk-best__t"><b>' + esc(best.titel) + '</b> wurde in den Warenkorb gelegt</span></p>';
  }
  function zeigeBest(titel) {
    clearTimeout(bestT);
    best = { titel: titel, zu: false };
    var q = qc(); var slot = q && q.querySelector('[data-gw-wk-best]'); if (slot) slot.innerHTML = '';
    setzeBest();
    bestT = setTimeout(function () {
      if (!best) return; best.zu = true;
      var p = q && q.querySelector('.gw-wk-best'); if (p) p.classList.add('gw-wk-best--zu');
      setTimeout(function () { best = null; }, 400);
    }, 4000);
  }

  /* ---------- Aktionen im Warenkorb (Menge, Entfernen) für Ansage und Fokus ---------- */
  var aktion = null;
  function bereichVon(el) {
    if (el.closest('.gw-wk-seite')) return 'seite';
    if (el.closest('.quick-cart.gw-wk')) return 'drawer';
    return null;
  }
  function merkeAktion(item, art, bereich) {
    var liste = Array.prototype.slice.call(item.parentNode.querySelectorAll('[data-input-item]'));
    aktion = { key: item.getAttribute('data-key'), titel: item.getAttribute('data-titel') || '', art: art, bereich: bereich, idx: liste.indexOf(item), t: Date.now() };
  }
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-subtract-quantity],[data-add-quantity],[data-remove-item]');
    if (!b) return;
    var item = b.closest('[data-input-item]'); var bereich = bereichVon(b);
    if (!item || !bereich) return;
    if (item.classList.contains('has-quantity-update') || (b.hasAttribute('data-subtract-quantity') && b.getAttribute('aria-disabled') === 'true')) {
      e.preventDefault(); e.stopPropagation(); return;
    }
    merkeAktion(item, b.hasAttribute('data-remove-item') ? 'weg' : (b.hasAttribute('data-add-quantity') ? 'plus' : 'minus'), bereich);
  }, true);
  d.addEventListener('change', function (e) {
    var inp = e.target; if (!inp.matches || !inp.matches('[data-quantity-input]')) return;
    var item = inp.closest('[data-input-item]'); var bereich = bereichVon(inp);
    if (!item || !bereich) return;
    var v = parseInt(inp.value, 10);
    if (isNaN(v) || v < 0) { inp.value = 1; v = 1; }
    merkeAktion(item, v === 0 ? 'weg' : 'menge', bereich);
  }, true);

  function nachAktion(bereich) {
    if (!aktion || aktion.bereich !== bereich || Date.now() - aktion.t > 15000) return;
    var a = aktion; aktion = null;
    var root = bereich === 'seite' ? seite() : qc(); if (!root) return;
    var dt = daten(root);
    var item = root.querySelector('[data-input-item][data-key="' + (window.CSS && CSS.escape ? CSS.escape(a.key) : a.key) + '"]');
    var rest = dt ? ' Zwischensumme ' + dt.summe + '. ' + versandSatz(dt) : '';
    if (item && a.art !== 'weg') {
      var inp = item.querySelector('[data-quantity-input]');
      var sel = a.art === 'plus' ? '[data-add-quantity]' : (a.art === 'minus' ? '[data-subtract-quantity]' : '[data-quantity-input]');
      var f = item.querySelector(sel); if (f) f.focus();
      ansage('Menge ' + a.titel + ': ' + (inp ? inp.value : '') + '.' + rest);
      return;
    }
    var items = root.querySelectorAll('[data-input-item]');
    var ziel = items[a.idx] || items[a.idx - 1];
    var link = ziel && ziel.querySelector('.gw-wk-pos__titel');
    if (link) link.focus();
    else {
      var h = root.querySelector(bereich === 'seite' ? '#gw-wk-s-h' : '.quick-cart__heading');
      if (h) { if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1'); h.focus(); }
    }
    ansage(a.titel + ' wurde entfernt.' + (items.length ? rest : ' Der Warenkorb ist leer.'));
  }

  /* ---------- Beobachter: Drawer und Warenkorbseite werden von Stiletto neu gefüllt ---------- */
  function beobachte(root, bereich) {
    if (!root || !window.MutationObserver) return;
    var t;
    new MutationObserver(function (recs) {
      var relevant = recs.some(function (r) {
        var z = r.target.nodeType === 1 ? r.target : r.target.parentNode;
        return !(z && z.closest && z.closest('[data-gw-wk-best]'));
      });
      if (!relevant) return;
      clearTimeout(t);
      t = setTimeout(function () {
        if (bereich === 'drawer') { setzeBest(); refreshFertig(); }
        nachAktion(bereich);
      }, 40);
    }).observe(root, { childList: true, subtree: true });
  }

  /* ---------- Drawer öffnen/schließen, Fokus zurück, Esc ---------- */
  var ausloeser = null;
  function cartIcon() {
    var icons = d.querySelectorAll('[data-js-cart-icon]');
    for (var i = 0; i < icons.length; i++) { if (sichtbar(icons[i])) return icons[i]; }
    return icons[0] || null;
  }
  function oeffnen(von) {
    ausloeser = von || d.activeElement;
    var icon = cartIcon();
    if (icon) icon.click(); else window.location.href = ROOT + 'cart';
  }
  d.addEventListener('click', function (e) {
    var icon = e.target.closest && e.target.closest('[data-js-cart-icon]');
    if (icon && e.isTrusted) ausloeser = icon;
  }, true);
  function fokusZurueck() {
    var z = ausloeser && ausloeser.isConnected && sichtbar(ausloeser) ? ausloeser : cartIcon();
    var q = qc();
    var a = d.activeElement;
    if (z && (!a || a === d.body || (q && q.contains(a)))) { try { z.focus({ preventScroll: true }); } catch (e) { z.focus(); } }
  }
  function beobachteWrapper() {
    var w = wrapper(); if (!w || !window.MutationObserver) return;
    var warOffen = w.classList.contains('active');
    new MutationObserver(function () {
      var jetzt = w.classList.contains('active');
      if (warOffen && !jetzt) {
        setTimeout(fokusZurueck, 560);
        var c = w.querySelector('.quick-cart__container'); if (c) c.style.transform = '';
      }
      if (!warOffen && jetzt) schliesseHinweis(false);
      warOffen = jetzt;
    }).observe(w, { attributes: true, attributeFilter: ['class'] });
  }
  function schliessen() {
    var q = qc(); var b = q && q.querySelector('.quick-cart__close-icon');
    if (b) b.click();
  }
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    if (istOffen()) { e.preventDefault(); schliessen(); return; }
    if (hinweis) { e.preventDefault(); schliesseHinweis(true); }
  });

  /* ---------- Bottom-Sheet: nach unten wischen (Griff und Kopfzeile) ---------- */
  (function wischen() {
    var q = qc(); if (!q) return;
    var y0 = null, dy = 0, cont = null;
    q.addEventListener('pointerdown', function (e) {
      if (!mqMobil.matches || !istOffen()) return;
      if (!e.target.closest('.gw-wk-kopf') || e.target.closest('button')) return;
      cont = q.querySelector('.quick-cart__container'); if (!cont) return;
      y0 = e.clientY; dy = 0; q.classList.add('gw-wk--wischen');
      try { e.target.setPointerCapture(e.pointerId); } catch (x) {}
    });
    q.addEventListener('pointermove', function (e) {
      if (y0 === null || !cont) return;
      dy = Math.max(0, e.clientY - y0);
      cont.style.transform = 'translateY(' + dy + 'px)';
    });
    function ende() {
      if (y0 === null) return;
      y0 = null; q.classList.remove('gw-wk--wischen');
      if (dy > 110) { cont.style.transform = ''; schliessen(); }
      else if (cont) cont.style.transform = '';
    }
    q.addEventListener('pointerup', ende);
    q.addEventListener('pointercancel', ende);
  })();

  /* ---------- Kurzer Hinweis (Karte / Kaufleiste / Snackbar) ---------- */
  var hinweis = null, hinweisT = null, hinweisZurueck = null;
  function schliesseHinweis(fokus) {
    clearTimeout(hinweisT);
    if (!hinweis) return;
    var h = hinweis; hinweis = null;
    var hatteFokus = h.el.contains(d.activeElement);
    if (h.sticky) h.sticky.classList.remove('gw-wk-bestaetigt');
    d.body.classList.remove('gw-wk-snack-offen');
    if (h.el.parentNode) h.el.parentNode.removeChild(h.el);
    if ((fokus || hatteFokus) && hinweisZurueck && hinweisZurueck.isConnected && sichtbar(hinweisZurueck)) hinweisZurueck.focus();
    else if (hatteFokus) { var i = cartIcon(); if (i) i.focus(); }
  }
  function planeAus(ms) {
    clearTimeout(hinweisT);
    hinweisT = setTimeout(function () {
      if (!hinweis) return;
      if (hinweis.el.matches(':hover') || hinweis.el.contains(d.activeElement)) { planeAus(1500); return; }
      schliesseHinweis(false);
    }, ms);
  }
  function zeigeHinweis(info, dt, von) {
    schliesseHinweis(false);
    hinweisZurueck = von;
    var at = land() === 'at';
    var n = dt ? dt.anzahl : '';
    var pct = dt ? dt.pct : 0;
    var kurz = dt ? (at ? dt.atKurz : dt.deKurz) : '';
    var sticky = d.getElementById('gw-sticky-atc');
    var el = d.createElement('div');
    var art;
    if (!mqMobil.matches) {
      art = 'karte';
      el.className = 'gw-wk-hw gw-wk-hw--karte';
      el.setAttribute('role', 'group');
      el.setAttribute('aria-labelledby', 'gw-wk-hw-h');
      var bild = info.bild ? '<img src="' + esc(info.bild) + '" alt="" width="56" height="56">' : '<span></span>';
      var vers = at ? '<p class="gw-wk-hw__v">' + esc(kurz) + '</p>'
        : '<p class="gw-wk-hw__v">' + esc(kurz) + (dt && dt.pct !== '100' ? ' (DE)' : '') + '</p>' + (dt && dt.pct !== '100' ? '<div class="gw-wk-hw__bar" aria-hidden="true"><span style="width:' + pct + '%"></span></div>' : '');
      el.innerHTML = '<div class="gw-wk-hw__o"><p class="gw-wk-hw__h" id="gw-wk-hw-h">' + ICON.check + 'In den Warenkorb gelegt</p>' +
        '<button type="button" class="gw-wk-hw__zu" data-gw-wk-hw-zu aria-label="Hinweis schließen">' + ICON.x + '</button></div>' +
        '<div class="gw-wk-hw__p">' + bild + '<div><p class="gw-wk-hw__t">' + esc(info.titel) + '</p><p class="gw-wk-hw__pr">' + esc(info.preis || '') +
        (info.grundpreis ? ' <span class="gw-wk-gp"><span class="visually-hidden">Grundpreis: </span>(' + esc(info.grundpreis) + ')</span>' : '') + '</p></div></div>' +
        vers + '<button type="button" class="gw-wk-btn gw-wk-btn--p" data-gw-wk-hw-auf>Warenkorb ansehen (' + esc(n) + ')</button>';
      d.body.appendChild(el);
      var icon = cartIcon();
      var r = icon ? icon.getBoundingClientRect() : null;
      var top = r && r.bottom > 0 ? r.bottom + 10 : 16;
      var right = r ? Math.max(16, window.innerWidth - r.right - 8) : 16;
      el.style.top = top + 'px'; el.style.right = right + 'px';
      if (r) el.style.setProperty('--gw-wk-pfeil', Math.max(12, Math.min(300, (r.left + r.width / 2) - (window.innerWidth - right - el.offsetWidth) - 7)) + 'px');
    } else {
      var leiste = '<div class="gw-wk-kl__bar" aria-hidden="true"><span style="width:' + (at ? 100 : pct) + '%"></span></div>' +
        '<div class="gw-wk-kl__in">' + ICON.check + '<div class="gw-wk-kl__txt"><b>Hinzugefügt</b><span>' + esc(kurz) + '</span></div>' +
        '<button type="button" class="gw-wk-btn gw-wk-btn--p" data-gw-wk-hw-auf>Warenkorb (' + esc(n) + ') ansehen</button></div>';
      if (sticky && sticky.classList.contains('is-visible')) {
        art = 'leiste';
        el.className = 'gw-wk-hw gw-wk-kl';
        el.style.position = 'absolute';
        el.innerHTML = leiste;
        sticky.appendChild(el);
        sticky.classList.add('gw-wk-bestaetigt');
      } else {
        art = 'snack';
        el.className = 'gw-wk-hw gw-wk-hw--snack';
        el.innerHTML = leiste;
        d.body.appendChild(el);
        d.body.classList.add('gw-wk-snack-offen');
      }
    }
    hinweis = { el: el, art: art, sticky: art === 'leiste' ? sticky : null };
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-gw-wk-hw-zu]')) { schliesseHinweis(true); return; }
      if (e.target.closest('[data-gw-wk-hw-auf]')) { var z = hinweisZurueck; schliesseHinweis(false); oeffnen(z); }
    });
    planeAus(art === 'karte' ? 4000 : 3500);
  }

  /* ---------- Nach dem Hinzufügen ---------- */
  function hinzugefuegt(o) {
    o = o || {};
    var it = o.item && o.item.items ? o.item.items[0] : (o.item || {});
    var erst = !ss(MERKER);
    var von = o.ausloeser || null;
    return warteAufRefresh(2500).then(function () {
      var q = qc();
      var dt = daten(q);
      var zeile = q && it.key ? q.querySelector('[data-input-item][data-key="' + (window.CSS && CSS.escape ? CSS.escape(it.key) : it.key) + '"]') : null;
      var info = {
        titel: (zeile && zeile.getAttribute('data-titel')) || it.product_title || it.title || 'Artikel',
        preis: zeile ? zeile.getAttribute('data-preis') : '',
        grundpreis: zeile ? zeile.getAttribute('data-grundpreis') : '',
        bild: zeile ? zeile.getAttribute('data-bild') : (it.image || '')
      };
      var satz = info.titel + ' wurde in den Warenkorb gelegt.' + (dt ? ' Warenkorb: ' + dt.anzahl + ' Artikel, Zwischensumme ' + dt.summe + '. ' + versandSatz(dt) : '');
      if (!q) { ansage(satz); return; }
      if (istOffen()) { ansage(satz); return; }
      if (erst) {
        ss(MERKER, '1');
        zeigeBest(info.titel);
        oeffnen(von);
        setTimeout(function () { ansage(satz); }, 450);
        return;
      }
      zeigeHinweis(info, dt, von);
      ansage(satz);
    });
  }

  /* Fehler am Kaufknopf (role=alert) */
  function fehlerEl(form, btn) {
    var anker = (btn && (btn.closest('.gw-atc-row') || btn)) || form;
    var el = form.querySelector('[data-gw-wk-fehler]');
    if (!el) {
      el = d.createElement('p');
      el.className = 'gw-wk-fehler'; el.setAttribute('role', 'alert'); el.setAttribute('data-gw-wk-fehler', ''); el.hidden = true;
      if (anker.parentNode) anker.parentNode.insertBefore(el, anker.nextSibling);
    }
    return el;
  }

  /* Produktformulare übernehmen (Capture-Phase, vor Stiletto) */
  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]') || f.matches('[data-gw-wk]')) return;
    if (!qc()) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (f._gwWkLaeuft) return;
    var btns = Array.prototype.slice.call(f.querySelectorAll('[type="submit"], .product-form__cart-submit'));
    var btn = e.submitter || btns[0] || null;
    var akt = d.activeElement;
    var von = (akt && akt !== d.body && akt.tagName === 'BUTTON') ? akt : btn;
    var fe = fehlerEl(f, btn); fe.hidden = true; fe.textContent = '';
    var alt = d.querySelector('#gw-sticky-atc .gw-lade-fehler'); if (alt) alt.parentNode.removeChild(alt);
    var tok = ladenAn(ladeZiele(btns, f), function () { if (f._gwWkLaeuft === tok) f._gwWkLaeuft = false; });
    f._gwWkLaeuft = tok;
    fetch(ROOT + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(f)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, s: r.status, j: j }; }, function () { return { ok: r.ok, s: r.status, j: {} }; }); })
      .then(function (x) {
        if (!x.ok || x.j.status) { var er = new Error((x.j && (x.j.description || x.j.message)) || ''); er.s = x.s || x.j.status; throw er; }
        d.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { detail: { item: x.j } }));
        return hinzugefuegt({ item: x.j, ausloeser: von });
      })
      .catch(function (err) {
        nachFehler(err.s);
        fe.textContent = fehlerText(err.s, err.message);
        fe.hidden = false;
        if (f.closest('.product__meta')) leistenFehler(fe.textContent);
        if (mqMobil.matches && !sichtbar(btn)) ansage(fe.textContent);
      })
      .then(function () {
        ladenAus(tok);
        if (f._gwWkLaeuft === tok) f._gwWkLaeuft = false;
      });
  }, true);

  /* Direktkauf in „Passt dazu“ im Drawer (Knopf, kein verschachteltes Formular) */
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-gw-wk-add]');
    if (!b || b.getAttribute('aria-disabled') === 'true') return;
    e.preventDefault();
    var fa = b.parentNode && b.parentNode.querySelector('[data-gw-wk-add-fehler]'); if (fa) fa.parentNode.removeChild(fa);
    var tok = ladenAn([b]);
    var titel = b.getAttribute('data-titel') || '';
    fetch(ROOT + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-gw-wk-add'), 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, s: r.status, j: j }; }, function () { return { ok: r.ok, s: r.status, j: {} }; }); })
      .then(function (x) {
        if (!x.ok || x.j.status) { var er = new Error((x.j && x.j.description) || ''); er.s = x.s || x.j.status; throw er; }
        d.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { detail: { item: x.j } }));
        return warteAufRefresh(2500).then(function () {
          var dt = daten(qc());
          var h = qc() && qc().querySelector('.quick-cart__heading'); if (h && istOffen()) h.focus();
          ansage(titel + ' wurde in den Warenkorb gelegt.' + (dt ? ' Zwischensumme ' + dt.summe + '. ' + versandSatz(dt) : ''));
        });
      })
      .catch(function (err) {
        ladenAus(tok); nachFehler(err.s);
        var fx = b.parentNode && b.parentNode.querySelector('[data-gw-wk-add-fehler]');
        if (!fx && b.parentNode) { fx = d.createElement('p'); fx.className = 'gw-wk-fehler gw-wk-pd__fehler'; fx.setAttribute('role', 'alert'); fx.setAttribute('data-gw-wk-add-fehler', ''); b.parentNode.insertBefore(fx, b.nextSibling); }
        if (fx) fx.textContent = fehlerText(err.s, err.message); else ansage(fehlerText(err.s, err.message));
      })
      .then(function () { ladenAus(tok); });
  });

  /* ---------- Zähler am Warenkorb-Symbol ---------- */
  function beobachteZaehler() {
    if (!window.MutationObserver) return;
    Array.prototype.forEach.call(d.querySelectorAll('[data-js-cart-count]'), function (z) {
      var alt = parseInt(z.textContent, 10) || 0;
      new MutationObserver(function () {
        var neu = parseInt(z.textContent, 10) || 0;
        if (neu > alt && !mqRuhig.matches) {
          z.classList.remove('gw-wk-bump'); void z.offsetWidth; z.classList.add('gw-wk-bump');
          setTimeout(function () { z.classList.remove('gw-wk-bump'); }, 500);
        }
        alt = neu;
      }).observe(z, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ---------- Warenkorbseite: Notiz speichern ---------- */
  d.addEventListener('change', function (e) {
    var t = e.target; if (!t.matches || !t.matches('[data-gw-wk-notiz]')) return;
    fetch(ROOT + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: t.value })
    }).then(function (r) { if (r.ok) ansage('Anmerkung gespeichert.'); }).catch(function () {});
  });

  beobachte(qc(), 'drawer');
  beobachte(seite(), 'seite');
  beobachteWrapper();
  beobachteZaehler();

  window.gwWk = { hinzugefuegt: hinzugefuegt, oeffnen: oeffnen, ansage: ansage, ladenAn: ladenAn, ladenAus: ladenAus, fehlerText: fehlerText, nachFehler: nachFehler };
})();
